export type QuizQuestionPair = {
    questionId: number;
    lessonId: number;
};

export type QuizQuestionDetail = {
    id: number;
    question?: string;
    text?: string;
};

export type QuizQuestionPairInput = {
    questionId?: number;
    lessonId?: number;
    question?: QuizQuestionDetail;
    lesson?: { id?: number };
};

export const normalizeQuizQuestionPairs = (
    pairs: QuizQuestionPairInput[] = []
): QuizQuestionPair[] | null => {
    const normalizedPairs = pairs.map((pair) => ({
        questionId: pair.questionId ?? pair.question?.id,
        lessonId: pair.lessonId ?? pair.lesson?.id,
    }));

    if (normalizedPairs.some((pair) => pair.questionId == null || pair.lessonId == null)) {
        return null;
    }

    return normalizedPairs as QuizQuestionPair[];
};

export const getQuizQuestionDetailsById = (
    pairs: QuizQuestionPairInput[] = []
): Record<number, QuizQuestionDetail> => pairs.reduce<Record<number, QuizQuestionDetail>>((detailsById, pair) => {
    if (pair.question?.id != null) {
        detailsById[pair.question.id] = pair.question;
    }
    return detailsById;
}, {});
